import gql from 'graphql-tag'
import di from 'di'

import addList from '@wittignl/js-core/apollo/mutations/addList'
import updateList from '@wittignl/js-core/apollo/mutations/updateList'
import deleteList from '@wittignl/js-core/apollo/mutations/deleteList'
import update from '@wittignl/js-core/apollo/mutations/update'

export default {

    create: function(logger){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($loggerInput: CreateLoggerInput!) {
                    createLogger(input: $loggerInput){
                        id
                    }
                }`,

            variables: {
                loggerInput: logger
            }

            // updateQueries: {
            //     AllLoggers: addList('createLogger', 'allLoggers.items'),
            // }
        });
    },

    update: function(logger){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($loggerInput: UpdateLoggerInput!) {
                    updateLogger(input: $loggerInput){
                        id
                    }
                }`,

            variables: {
                loggerInput: logger
            }

            // updateQueries: {
            //     AllLoggers: updateList('updateUser', 'allUsers.items'),
            //     FindLogger: update('createLogger', 'findGarment')
            // }
        });
    },

    executeAction: function(input){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($input: ExecuteLoggerActionInput!) {
                    executeLoggerAction(input: $input){
                        id
                    }
                }`,

            variables: {
                input
            }
        });
    },

    updateActionDeadline: function(deadline, loggers){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($deadline: Int, $loggers: [ID!]!) {
                    updateActionDeadline(deadline: $deadline, loggers: $loggers){
                        id
                    }
                }`,

            variables: {
                deadline, loggers
            }
        });
    }
}
